module.exports = __webpack_public_path__ + "assets/img/SIL_8.183ffe87.png";